const brand = process.env.BRAND || '';

export const isCustomerLibraryEnabledForBrand = (activeBrand: string) =>
  activeBrand === 'dev' || activeBrand === 'xiangxing';

export const customerLibraryEnabled = isCustomerLibraryEnabledForBrand(brand);
